export default __webpack_public_path__ + "static/media/post-img3.36ead21c.jpg";